import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=4dbc9d92&scoped=true&"
var script = {}
import style0 from "./notice.vue?vue&type=style&index=0&id=4dbc9d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbc9d92",
  null
  
)

export default component.exports